import React, { useState, useEffect } from "react";
import { User, Lightbulb, Library, Phone, Sun, Moon } from "lucide-react";
import "../styles/Header.css";

const NAV_ITEMS = [
  { id: "about", label: "About", icon: User },
  { id: "skills", label: "Skills", icon: Lightbulb },
  { id: "projects", label: "Projects", icon: Library },
  { id: "contact", label: "Contact", icon: Phone },
];

const Header = ({ toggleTheme, currentTheme }) => {
  const [activeId, setActiveId] = useState("about");

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");

    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isAtBottom = scrollPosition >= documentHeight - 100;

      if (isAtBottom) {
        setActiveId("contact");
        return;
      }

      let current = "about";
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (window.scrollY >= sectionTop - 300) {
          current = section.getAttribute("id") || "about";
        }
      });
      setActiveId(current);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`island-nav ${currentTheme}`}>
      <div className="nav-items-wrapper">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = activeId === item.id;

          return (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={`nav-item ${isActive ? "active" : ""}`}
              aria-current={isActive ? "page" : undefined}
            >
              <span className="nav-text">{item.label}</span>
              <span className="nav-icon">
                <Icon size={22} strokeWidth={2.5} />
              </span>
              {isActive && <div className="active-pill" />}
            </a>
          );
        })}
      </div>

      <div className="theme-toggle-wrapper">
        <label className="toggle-switch" aria-label="Toggle Theme">
          <input
            type="checkbox"
            checked={currentTheme === "dark"}
            onChange={toggleTheme}
          />
          <div className="slider">
            {/* Background Scenery Elements */}
            <div className="bg-layer">
              <span className="star star-1"></span>
              <span className="star star-2"></span>
              <span className="star star-3"></span>
              <span className="star star-4"></span>
              <span className="cloud cloud-1"></span>
              <span className="cloud cloud-2"></span>
              <span className="cloud cloud-3"></span>
            </div>

            {/* The Moving Knob */}
            <div className="knob">
              <Sun size={14} className="icon sun" strokeWidth={3} />
              <Moon size={14} className="icon moon" strokeWidth={3} />
            </div>
          </div>
        </label>
      </div>
    </nav>
  );
};

export default Header;